import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { jobSearchSchema } from "@/features/admin-jobs/api";
import { JobsPage } from "@/features/admin-jobs/JobsPage";
function Page() {
  const { session } = Route.useRouteContext();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return <JobsPage key={session.user.id} actorId={session.user.id} search={search} navigate={next => void navigate({ search: next })} />;
}
export const Route = createFileRoute("/_authenticated/_protected/_admin/admin/jobs")({
  validateSearch: (search: Record<string, unknown>) => jobSearchSchema.parse(search),
  search: { middlewares: [stripSearchParams(jobSearchSchema.parse({}))] },
  component: Page,
});
